import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { CAMERA_SOUND_VIOLATION, CHEATING_VIOLATION, OTHER_VIOLATION } from "../components/timeline/js/Marker";
import Timeline from "../components/timeline";
import SynchronizedVideos from "../components/SynchronizedVideos";
import "../styles/Watch.css";
import "video.js/dist/video-js.css";
import queryString from "query-string";
import { set, startOfToday } from "date-fns";
import EventScale from "../components/EventScale";
import EventScaleScreen from "../components/EventScaleScreen";
import SummaryDataMarkup from "../components/SummaryDataMarkup";
import SuspiciousApp from "../components/SuspiciousApp";
import { host, socket } from "../libs/webRTC";
import axios from "../libs/httpClient";
import { pollSessionAnalysis } from '../libs/sessionAnalysisPolling';
import moment from "moment";
import "moment/locale/ru";
import fronLogger from "../libs/logger";
import { Box, Typography, Link, Button, TextField, Table, TableHead, TableCell, TableBody, TableRow } from "@mui/material";
import NavStruct from "../components/NavStruct"
import '../i18n';
import { useTranslation } from 'react-i18next';
import DuplicateVideos from "../components/DuplicateVideos";

export default function Watch() {
    let navigate = useNavigate();
    let timelineRef = useRef();
    let location = useLocation();
    const [t, i18n] = useTranslation();
    let token = location.pathname.split('/').at(-1);
    // console.log("Token: ", token);
    const webcamJsOptions = {
        src: `${host}/links/webcam/${token}`
    };

    function requestSeek(source, time) {
        const seconds = Number(time);
        if (!Number.isFinite(seconds) || seconds < 0) return;
        setSeekRequest(previous => ({ source, time: seconds, revision: (previous?.revision || 0) + 1 }));
    }
    function setTimeWeb(time) { requestSeek('camera', time); }
    function setTimeScreen(time) { requestSeek('screen', time); }

    useEffect(() => {
        let parsed = queryString.parse(location.search);
        for (let i in parsed) {
            if (i === "webTime") {
                if (parsed[i] !== '' && Number(parsed[i]) >= 0) {
                    let time = parsed[i];    //
                    setTimeWeb(time);
                }
            } else if (i === "screenTime") {
                if (parsed[i] !== '' && Number(parsed[i]) >= 0) {
                    let time = parsed[i];   //
                    setTimeScreen(time);
                }
            }
        }
    }, [location.search]);


    const windowJsOptions = {
        src: `${host}/links/window/${token}`
    };

    const weblink = `/api/links/webcam/${token}`;
    const screenlink = `/api/links/window/${token}`;
    const weblinkrec = `/api/links/res_webcam/${token}`;
    const screenlinkrec = `/api/links/res_window/${token}`;

    const [uploadComment, setUploadComment] = useState('');
    useEffect(() => {
        const controller = new AbortController();
        setUploadComment('');
        axios.get(`${host}/uploadedSessions/${token}`, { signal: controller.signal })
            .then(({ data }) => { if (!controller.signal.aborted) setUploadComment(data.comment || ''); })
            .catch(() => {});
        return () => controller.abort();
    }, [token]);
    const [rowData, setRawData] = useState();
    const [markup, setMarkup] = useState([]);
    const [seekRequest, setSeekRequest] = useState(null);
    const [screenCastMarkup, setScreenCastMarkup] = useState([]);



    const [showForm, setFormStatus] = useState(false);
    const [queryTime, setQueryTime] = useState(window.location.origin + window.location.pathname);
    const [screenTimeForLink, setScreenTimeForLink] = useState('');
    const [webTimeForLink, setWebTimeForLink] = useState('');
    const [linkError, setLinkError] = useState('');

    // TODO: review - seems it doesn't work
    function changeLinkTime(event) {
        if (/^\d+$/.test(event.target.value)) { // is number?

            const nextScreenTime = event.target.id === "screenLink" ? event.target.value : screenTimeForLink;
            const nextWebTime = event.target.id === "webLink" ? event.target.value : webTimeForLink;
            if (event.target.id === "screenLink") setScreenTimeForLink(nextScreenTime);
            if (event.target.id === "webLink") setWebTimeForLink(nextWebTime);
            setLinkError('');
            setQueryTime(window.location.origin + window.location.pathname + "?webTime=" + nextWebTime + '&' + "screenTime=" + nextScreenTime);

        } else {
            setLinkError("Введите целочисленное положительное число...");
        }
    }

    function setLink() {
        return queryTime;
    }

    function to_logs() {

        navigate(`/logTable?token=${token}`);
    }

    function linkForVideo() {

        const viewData = () => {
            if (showForm) setFormStatus(false);
            else setFormStatus(true);
        };
        // TODO: review - seems it doesn't work
        return (
            <Box sx={{ padding: '30px 30px 20px 30px' }}>
                <Button onClick={viewData} variant="contained" sx={{ marginBottom: '10px' }}>Ссылка с точным временем</Button>
                {showForm && (
                    <Box>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
                            <TextField
                                id="webLink"
                                variant="outlined"
                                label="Запись веб-камеры(сек)"
                                onChange={changeLinkTime}
                                sx={{ width: '250px' }}
                            />
                            <TextField
                                id="screenLink"
                                variant="outlined"
                                label="Запись экрана(сек)"
                                onChange={changeLinkTime}
                                sx={{ width: '250px' }}
                            />
                            <Button disabled onClick={setLink} type="submit" variant="contained">Сгенерировать</Button>
                        </Box>
                        <p id="link" style={{ overflowWrap: 'anywhere' }}>{linkError || queryTime}</p>
                    </Box>
                )}
            </Box>
        );
    }

    useEffect(() => {
        setRawData(undefined);
        setMarkup([]);
        setScreenCastMarkup([]);
        return pollSessionAnalysis({
            load: async signal => {
                // Read markup after status: a terminal status must not be paired
                // with a 404 that raced just ahead of the final ML callback.
                const row = await axios.get(`${host}/studentData/session/${token}`, { signal });
                const [camera, screen] = await Promise.all([
                    axios.get(`${host}/ml/markup/${token}`, { signal }).catch(error => {
                        if (error.response?.status === 404) return { data: null };
                        throw error;
                    }),
                    axios.get(`${host}/ml/screencastMarkup/${token}`, { signal })
                ]);
                return { row: row.data, camera: camera.data, screen: screen.data };
            },
            onData: ({ row, camera, screen }) => {
                setRawData(row);
                if (camera && !camera.error) setMarkup(camera);
                if (screen && !screen.error) setScreenCastMarkup(screen);
            },
            onError: error => fronLogger(token, error, 'error', 'Watch.js')
        });
    }, [token]);

    //Style for ml cards from screencast and webcam
    const screenMlCardsStyle = {
        width: '100%',
        overflow: 'auto',
        maxHeight: '32vh', minHeight: 160,
    };

    const webcamMlCardsStyle = {
        width: '100%',
        overflow: 'auto',
        maxHeight: '32vh', minHeight: 160,
    };


    function parseTime(date) {
        if (date) {
            let result = moment(date);
            return result.isValid() ? result.format("LLL") : date;
        }
        else return "-"
    }

    // //TimeLine func
    function getMarkersForWeb() {
        let violationMarkupForLine = [];

        for (let i in markup.result) {
            let date = new Date(0);
            date.setSeconds(markup.result[i].start_time); // specify value for SECONDS here
            let timeStart = date.toISOString().substr(11, 8);
            date = new Date(Number(markup.result[i].end_time) * 1000);
            let timeEnd = date.toISOString().substr(11, 8);
            timeStart = timeStart.split(":");
            timeEnd = timeEnd.split(":");


            let violationWeb = '';
            for (let j in markup.result[i].anomalies) {
                if (markup.result[i].anomalies[j]) {
                    violationWeb += ` ${j}`;
                }
            }
            violationMarkupForLine.push(
                {
                    violation: i % 2 === 0 ? CAMERA_SOUND_VIOLATION : CHEATING_VIOLATION,
                    currentViolation: violationWeb,
                    source: {
                        value: set(startOfToday(), {
                            hours: timeStart[0],
                            minutes: timeStart[1],
                            seconds: timeStart[2]
                        })
                    },
                    target: { value: set(startOfToday(), { hours: timeEnd[0], minutes: timeEnd[1], seconds: timeEnd[2] }) }
                }
            );
        }


        return violationMarkupForLine;
    }

    function getMarkersForScreen() {
        let violationMarkupForLine = [];

        for (let i in screenCastMarkup.result) {
            // console.log('markers for screen: ', screenCastMarkup);
            let date = new Date(0);
            date.setSeconds(screenCastMarkup.result[i].start_time); // specify value for SECONDS here
            let timeStart = date.toISOString().substr(11, 8);
            date = new Date(Number(screenCastMarkup.result[i].end_time) * 1000);
            let timeEnd = date.toISOString().substr(11, 8);
            timeStart = timeStart.split(":");
            timeEnd = timeEnd.split(":");


            let violationWeb = '';
            for (let j in screenCastMarkup.result[i].warn) {
                violationWeb += ` ${screenCastMarkup.result[i].warn[j]}`;
            }
            violationMarkupForLine.push(
                {
                    violation: i % 2 === 0 ? CAMERA_SOUND_VIOLATION : CHEATING_VIOLATION,
                    currentViolation: violationWeb,
                    source: {
                        value: set(startOfToday(), {
                            hours: timeStart[0],
                            minutes: timeStart[1],
                            seconds: timeStart[2]
                        })
                    },
                    target: { value: set(startOfToday(), { hours: timeEnd[0], minutes: timeEnd[1], seconds: timeEnd[2] }) }
                }
            );
        }


        return violationMarkupForLine;
    }


    function getCurrentTime() {
        return startOfToday();
    }

    function duratationToSec(time) {
        let seconds = 0;
        time = time.split(":");
        if (time.length !== 1) {
            if (time.length === 2) {
                time.unshift(0);
            }
            seconds = 3600 * time[0] + 60 * time[1] + time[2] / 1;
        }
        return seconds;
    }

    function getTimeLineInterval(source = 'camera') {
        const startTime = startOfToday();
        const endTime = set(startTime, { seconds: rowData && duratationToSec(rowData[source === 'screen' ? 'screenDuration' : 'webcamDuration']) });
        return [startTime, endTime];
    }

    //end Time line func

    function prepareTime(startTime = null, endTime = null) {
        if (startTime) {
            let resultString = parseTime(rowData.startTime);
            if (endTime) {
                resultString += `   —   ${parseTime(rowData.endTime)}`
            } else {
                resultString += "   —   " + t("Не закончена");
            }
            return resultString;
        }
        return t('Не начата')
    }

    function isStart() {
        return (rowData && (!(rowData["pressedStartButton"] === "Нет") || rowData.endTime || rowData.statuses.isEnded));
    }

    function strStatus(statuses){
        if (!statuses.isUploaded & !statuses.isRemote) return "Стандартная сессия онлайн-прокторинга"
        if (statuses.isUploaded) return 'Самостоятельная загрузка'
        if (statuses.isRemote) return 'Загрузка через плагин'

    }

    const start = isStart();
    return (
        <Box sx={{ minHeight: '100vh', maxWidth: 1800, mx: 'auto', px: { xs: 1, md: 3 } }}>
            <Box sx={{ margin: '20px 0px 20px 0' }}>
                <NavStruct />
            </Box>
            <Box sx={{ bgcolor: 'background.paper', borderRadius: '20px', width: '100%' }}>
                <Typography variant="h5" color="text.primary" sx={{ padding: '20px 0px 0px 20px' }}>{rowData && rowData["full_name"]}</Typography>
                <DuplicateVideos key={token} token={token} />

                {rowData?.userId && (
                    <Button component ="a" href={`/table/other?studentId=${encodeURIComponent(rowData.userId)}`} target="_blank" rel="noopener noreferrer" variant="outlined" sx={{margin: "16px 20px"}}>
                        Перейти к списку всех сессий данного студента
                    </Button>
                )}
                <Table size="medium" sx={{ width: '50%', margin: 'auto' }}>
                    <TableBody>
                        <TableRow>
                            <TableCell sx={{ textAlign: 'center' }}>{t("Время сессии")}</TableCell>
                            <TableCell sx={{ textAlign: 'center' }}>{rowData && prepareTime(rowData.startTime, rowData.endTime)}</TableCell>
                        </TableRow>
                        {rowData &&
                        <>
                            <TableRow>
                                <TableCell sx={{ textAlign: 'center' }}>{t("Ссылка на видео")}</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}><Link href={screenlink}>Экран</Link> &nbsp;|&nbsp; <Link href={weblink}>Камера</Link></TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ textAlign: 'center' }}>{t("Длительность")}</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>{ rowData.screenDuration + "    |    " + rowData.webcamDuration }</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ textAlign: 'center' }}>{t("Обработка")}</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>{ prepareTime(rowData.mlResultStart, rowData.mlResultEnd) + `    (${rowData.mlResultStatus})` }</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell sx={{ textAlign: 'center' }}>{t("Тип записи")}</TableCell>
                                <TableCell sx={{ textAlign: 'center' }}>{ strStatus(rowData.statuses) }</TableCell>
                            </TableRow>
                        </>
                        }
                    </TableBody>
                </Table>
                {uploadComment && <Box sx={{ p: 3 }}><Typography variant="h6">Причина самостоятельной записи</Typography><Typography sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{uploadComment}</Typography></Box>}
                {rowData && (rowData["presenceWebcamAndMicrophone"] === true ? <></> :
                    <Box sx={{ marginLeft: '30px' }}>
                        <SummaryDataMarkup rowData={rowData} />
                    </Box>
                )}
                <Button onClick={to_logs} variant="contained" sx={{ margin: '20px 0px 0px 30px' }}> Логи</Button>
                <Box>
                    {start ? <SynchronizedVideos
                        cameraSrc={webcamJsOptions.src}
                        screenSrc={windowJsOptions.src}
                        hasCamera={!rowData.presenceWebcamAndMicrophone}
                        synchronization={rowData.videoSynchronization}
                        seekRequest={seekRequest}
                        cameraEvents={markup.result && <Box className="watch-stream-events">
                            <Typography variant="h6">События камеры</Typography>
                            <Timeline markers={getMarkersForWeb()} value={getCurrentTime()} ref={timelineRef}
                                timelineInterval={getTimeLineInterval()} setViolation={setTimeWeb} />
                            <Box style={webcamMlCardsStyle}><EventScale markup={markup} setViolation={setTimeWeb} token={token} /></Box>
                        </Box>}
                        screenEvents={screenCastMarkup.result && <Box className="watch-stream-events">
                            <Typography variant="h6">События экрана</Typography>
                            <Timeline markers={getMarkersForScreen()} value={getCurrentTime()}
                                timelineInterval={getTimeLineInterval('screen')} setViolation={setTimeScreen} />
                            <Box style={screenMlCardsStyle}><EventScaleScreen screenCastMarkup={screenCastMarkup} setViolation={setTimeScreen} token={token} /></Box>
                        </Box>}
                    /> : <Typography sx={{ p: 3 }}>Студент не начал запись</Typography>}
                    {start && linkForVideo()}
                </Box>
            </Box>
            <Box sx={{ margin: '30px 0px 0px 50px' }}>
                <SuspiciousApp />
            </Box>
        </Box>
    );
}
